import { SuperLink as Link } from "@/components/common/super-link";
import { createPath } from "@/service/routing/routing";
import { Button } from "@/components/ui/button";
import { PercentIcon } from "lucide-react";

export const PackageButton = ({
  packages,
}: {
  packages: PackagePreviewVM[];
}) => {
  if (packages.length === 0) {
    return <></>;
  }

  return (
    <Button
      asChild
      variant={"ghost"}
      className="hover:text-remedium-blue h-fit justify-start py-4 pl-0 text-xs hover:bg-transparent"
    >
      <Link
        href={createPath("ecommerce.package.show", { slug: packages[0].slug })}
        className="text-remedium-blue"
      >
        <PercentIcon className="h-2.5 w-2.5" /> Kup taniej w pakiecie
      </Link>
    </Button>
  );
};
